import { createPortal } from 'react-dom';
import { Lightbox } from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

export function LightboxPortal({ open, index, slides, onClose }) {
  if (typeof document === 'undefined') return null;
  return createPortal(
    <Lightbox
      open={open}
      index={index}
      close={onClose}
      slides={slides}
      plugins={[Thumbnails, Zoom]}
      carousel={{
        padding: 0,
        spacing: 0,
        imageFit: 'contain',
      }}
      thumbnails={{
        position: 'bottom',
        width: 120,
        height: 80,
      }}
    />,
    document.body
  );
}
